var map = {
	"./icon--arrow-right.svg": 2609,
	"./icon--chevron-down.svg": 1461,
	"./icon--close.svg": 3098,
	"./icon--download.svg": 2381,
	"./icon--external.svg": 8634,
	"./icon--facebook.svg": 6795,
	"./icon--instagram.svg": 57,
	"./icon--link.svg": 6624,
	"./icon--linkedin.svg": 8809,
	"./icon--mail.svg": 1484,
	"./icon--menu.svg": 8365,
	"./icon--quote.svg": 6595,
	"./icon--search.svg": 7997,
	"./icon--share.svg": 9742,
	"./icon--speak.svg": 7549,
	"./icon--whatsapp.svg": 6011,
	"./icon--x.svg": 4122,
	"./icon--youtube.svg": 6709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2117;